<div class="row mb-3">
  <div class="col-3">
    <label class="form-label fw-bold small">Brand</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-box"></i></span>
      <select class="form-select" [(ngModel)]="filters.product" (ngModelChange)="changeProduct()">
        <option [ngValue]="null">{{ getProductPlaceholder() }}</option>
        @for (product of products; track product) {
          <option [ngValue]="product"> {{ product.name }}</option>
        }
      </select>
    </div>
  </div>

  <div class="col-3">
    <label class="form-label fw-bold small">Offer</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-basket"></i></span>
      <select class="form-select" [(ngModel)]="filters.offer" [appElementLoader]="offerLoading"
              (ngModelChange)="changeOffer()">
        <option [ngValue]="null">{{ getOfferPlaceholder() }}</option>
        @for (offer of offers; track offer) {
          <option [ngValue]="offer">{{ offer.name }}</option>
        }
      </select>
    </div>
  </div>

  <div class="col-3">
    <label class="form-label fw-bold small">Promotion link</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-window"></i></span>
      <select class="form-select landing-page-activity" [(ngModel)]="filters.landingPageActivity"
              (ngModelChange)="refreshLandingPages()" title="Only promotion links with at least 1 click since…">
        <option [ngValue]="null">Activity</option>
        @for (period of activityPeriods; track period.identifier) {
          <option [ngValue]="period.identifier">{{ period.shortLabel }}</option>
        }
      </select>
      <select class="form-select" [(ngModel)]="filters.landingPage"
              [appElementLoader]="landingPageLoading">
        <option [ngValue]="null">{{ getLandingPagePlaceholder() }}</option>
        @for (landingPage of landingPages; track landingPage) {
          <option
            [ngValue]="landingPage">{{ landingPage.name }}
          </option>
        }
      </select>
    </div>
  </div>

  <div class="col-3">
    <label class="form-label fw-bold small">Pools</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-window"></i></span>
      <select class="form-select" [(ngModel)]="filters.pool">
        <option [ngValue]="null">{{ getPoolPlaceholder() }}</option>
        @for (pool of pools; track pool) {
          <option
            [ngValue]="pool">{{ pool.name }}
          </option>
        }
      </select>
    </div>
  </div>
</div>

<div class="row mb-3">
  <div class="col-3">
    <label for="accountType" class="form-label fw-bold small">Account Type</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-people"></i></span>
      <select class="form-select" id="accountType" [(ngModel)]="filters.accountType"
              (ngModelChange)="refreshPartners()">
        <option [ngValue]="null">All account types</option>
        @for (accountType of partnerAccountTypeList; track accountType) {
          <option
            [ngValue]="accountType">{{ 'partnerAccountType.' + accountType | translate }}
          </option>
        }
      </select>
    </div>
  </div>

  @if (isMediaBuy()) {
    <div class="col-3">
      <label class="form-label fw-bold small">Advertising Platform</label>
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-bar-chart-line"></i></span>
        <select class="form-select" [(ngModel)]="filters.advertisingPlatform"
                (ngModelChange)="refreshPartners()">
          <option [ngValue]="null">All platforms</option>
          @for (advertisingPlatform of advertisingPlatformList; track advertisingPlatform) {
            <option
              [value]="advertisingPlatform.id">{{ advertisingPlatform.name }}
            </option>
          }
        </select>
      </div>
    </div>
  }

  <div class="col-3">
    <label class="form-label fw-bold small">Account Manager</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-person-circle"></i></span>
      <select class="form-select" [(ngModel)]="filters.accountManager"
              (ngModelChange)="refreshPartners()">
        <option [ngValue]="null">All account managers</option>
        @for (accountManager of accountManagers; track accountManager) {
          <option
            [ngValue]="accountManager">{{ accountManager }}
          </option>
        }
      </select>
    </div>
  </div>

  <div [ngClass]="{'col-3':isMediaBuy(),'col-6':!isMediaBuy()}">
    <label class="form-label fw-bold small">Partner</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-diagram-3"></i></span>
      <app-dropdown-select [(ngModel)]="filters.partner" [appElementLoader]="partnerLoading" [multiple]="true"
                           [selectAll]="true">
        @for (partner of partners; track partner) {
          <app-dropdown-select-option [value]="partner.id">
            {{ partner }}
          </app-dropdown-select-option>
        }
      </app-dropdown-select>
    </div>
  </div>
</div>

<div class="row mb-3">
  <div class="col-3">
    <label class="form-label fw-bold small">Language</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-translate"></i></span>
      <app-dropdown-select [(ngModel)]="filters.lang">
        <app-dropdown-select-option [value]="null">All languages</app-dropdown-select-option>
        @for (lang of languages; track lang) {
          <app-dropdown-select-option [value]="lang.isoCode">
            <img [ngSrc]="langService.getLanguageFlag(lang)" [alt]="lang.name" class="country-flag"
                 width="24" height="24">
            {{ lang.name }}
          </app-dropdown-select-option>
        }
      </app-dropdown-select>
    </div>
  </div>

  <div class="col-3">
    <label class="form-label fw-bold small">Country</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
      <app-dropdown-select [(ngModel)]="filters.country">
        <app-dropdown-select-option [value]="null">All countries</app-dropdown-select-option>
        @for (country of countries; track country) {
          <app-dropdown-select-option [value]="country.isoCode">
            <img [ngSrc]="countryService.getFlag(country.isoCode)" [alt]="country.name"
                 class="country-flag"
                 width="24" height="24">
            {{ country.name }}
          </app-dropdown-select-option>
        }
      </app-dropdown-select>
    </div>
  </div>

  <div class="col-3">
    <label for="coreg" class="form-label fw-bold small">P2</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-diagram-3"></i></span>
      <select id="coreg" class="form-select" [(ngModel)]="filters.coreg">
        <option [ngValue]="null">All</option>
        <option [ngValue]="0">Without P2</option>
        <option [ngValue]="1">Only P2</option>
      </select>
    </div>
  </div>

  <div class="col-3">
    <label for="ar" class="form-label fw-bold small">Xsell</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-bar-chart"></i></span>
      <select id="ar" class="form-select" [(ngModel)]="filters.cross">
        <option [ngValue]="null">All</option>
        <option [ngValue]="0">Without Xsell</option>
        <option [ngValue]="1">Only Xsell</option>
      </select>
    </div>
  </div>
</div>

<div class="row mb-3">
  <div class="col">
    <label class="form-label fw-bold small">SubID</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-filter"></i></span>
      <input type="text" class="form-control" value="" [(ngModel)]="filters.subid">
    </div>
  </div>

  <div class="col">
    <label class="form-label fw-bold small">Tracker 1</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input type="text" class="form-control" value="" [(ngModel)]="filters.tc1">
    </div>
  </div>
  <div class="col">
    <label class="form-label fw-bold small">Tracker 2</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input type="text" class="form-control" value="" [(ngModel)]="filters.tc2">
    </div>
  </div>
  <div class="col">
    <label class="form-label fw-bold small">Tracker 3</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input type="text" class="form-control" value="" [(ngModel)]="filters.tc3">
    </div>
  </div>
  <div class="col">
    <label class="form-label fw-bold small">Tracker 4</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input type="text" class="form-control" value="" [(ngModel)]="filters.tc4">
    </div>
  </div>
  <div class="col">
    <label class="form-label fw-bold small">Source</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
      <input type="text" class="form-control" value="" [(ngModel)]="filters.source">
    </div>
  </div>
</div>

<div class="row mb-3">
  <div class="col-6">
    <label class="form-label fw-bold small">Sequence(s)</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-list-task"></i></span>
      <app-dropdown-select [(ngModel)]="filters.goalTypeNames" [multiple]="true">
        @for (goalTypeName of goalTypeNameList; track goalTypeName) {
          <app-dropdown-select-option
            [value]="goalTypeName.key">
            {{ goalTypeName.label }}
          </app-dropdown-select-option>
        }
      </app-dropdown-select>
    </div>
  </div>

  <div class="col-3">
    <label for="paid" class="form-label fw-bold small">Paid</label>
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-cash-coin"></i></span>
      <select id="paid" class="form-select" [(ngModel)]="filters.paid">
        <option [ngValue]="null">All</option>
        <option [ngValue]="true">Yes</option>
        <option [ngValue]="false">No</option>
      </select>
    </div>
  </div>

  <ng-content></ng-content>
</div>
